<template>
  <section v-loading.fullscreen.lock="loading" class="set">
    <com-tabs
      :list="mineInfo.obj.tabs"
      class="set-tabs"
      :default-tab="activeTab"
      direction="column"
      @change="changeTab"
    >
      <template v-slot:text="{ obj }">
        <div :class="{ activeTab: activeTab == obj.key }" class="set-tabs-item">
          {{ obj.name }}
        </div>
      </template>
    </com-tabs>
    <div>
      <!-- 学校信息 -->
      <com-school v-show="activeTab == 0" :id="user.school_id" @input="init" />
      <!-- 功能室 -->
      <com-user
        v-show="activeTab == 1"
        :list="data1"
        @control="handleControlUser"
      />
      <com-fun
        v-show="activeTab == 2"
        :list="data2"
        @control="handleControlFun"
      />
      <com-grade
        v-show="activeTab == 3"
        :list="data4"
        @control="handleControlGrade"
      />
    </div>
    <com-user-wx :id="userWx.id" v-model="userWx.show" />
    <com-user-add
      :id="userAdd.id"
      v-model="userAdd.show"
      :rules="mineInfo.obj.userRules"
      @input="init"
    />
    <com-fun-add
      :id="funAdd.id"
      v-model="funAdd.show"
      :rules="mineInfo.obj.funRules"
      @input="init"
    />
    <com-fun-user
      :id="funUser.id"
      v-model="funUser.show"
      :id1="funUser.id1"
      :list="data1"
      @input="init"
      @lock="handleLock"
    />
    <com-grade-add
      :id="gradeAdd.id"
      v-model="gradeAdd.show"
      :rules="mineInfo.obj.gradeRules"
      @input="init"
    />
    <!-- <com-wx-phone
      v-model="wxAdd.show"
      :id="wxAdd.id"
      :rules="mineInfo.obj.funRules"
      @input="init"
    /> -->
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import comTabs from '@/components/comTabs'
import comSchool from './details/comSchool/index.vue'
import comWxPhone from './details/comSchool/comWxPhone.vue'
import comPhoneEdit from './details/comSchool/comPhoneEdit.vue'
import comUser from './details/comUser/index.vue'
import comUserWx from './details/comUser/comUserWx.vue'
import comUserAdd from './details/comUser/comUserAdd.vue'
import comFun from './details/comFun/index.vue'
import comFunAdd from './details/comFun/comFunAdd.vue'
import comFunUser from './details/comFun/comFunUser.vue'
import comGrade from './details/comGrade/index.vue'
import comGradeAdd from './details/comGrade/comGradeAdd.vue'
import api from '@/api/app'
import mock from '@/utils/mock'
export default {
  components: {
    comTabs,
    comSchool,
    comUser,
    comUserWx,
    comFunUser,
    comUserAdd,
    comFun,
    comFunAdd,
    comGrade,
    comGradeAdd,
    comWxPhone,
    comPhoneEdit
  },
  data() {
    return {
      activeTab: 0,
      mineInfo: mock.mine.set.viewInfo,
      mineInit: mock.mine.set.init,
      data1: null,
      data2: null,
      data4: null,
      schoolObj: null,
      loading: false,
      userWx: {
        show: false,
        id: null
      },
      userAdd: {
        show: false,
        id: null
      },
      funUser: {
        show: false,
        id: null
      },
      funAdd: {
        show: false,
        id: null,
        id1: null
      },
      gradeAdd: {
        show: false,
        id: null
      },
      requestParams: {
        id: null
      },
      wxAdd: {
        show: false,
        id: null
      }
    }
  },
  created() {},
  mounted() {
    this.loading = true
    this.init()
    if (this.$route.query.activeTab) {
      this.activeTab = Number(this.$route.query.activeTab)
    }
  },
  methods: {
    async init() {
      this.data1 = await this.mineInit.data1()
      this.data2 = await this.mineInit.data2()
      this.data4 = await this.mineInit.data4()
      this.loading = false
    },
    changeTab(x, y) {
      this.activeTab = x
    },
    handleLock(v, x) {
      if (x) {
        const obj = {}
        obj.id = v
        obj.internal_user_id = x
        this.$confirm('确认绑定该用户吗?', '提示', {})
          .then(() => {
            api.mine.update.lock(obj).then(() => {
              this.$message({
                message: '功能室绑定用户成功',
                type: 'success'
              })
              this.init()
            })
          })
          .catch(() => {})
      }
    },
    handleControlUser(v, x) {
      switch (x) {
        case 'add':
          this.userAdd.show = true
          this.userAdd.id = null
          break
        case 'wx':
          this.userWx.show = true
          this.userWx.id = v.id
          break
        case 'edit':
          this.userAdd.show = true
          this.userAdd.id = v.id
          break
        default:
          this.$confirm('确认删除该用户吗?', '提示', {})
            .then(() => {
              api.mine.delete.user({ id: v.id }).then(() => {
                this.$message({
                  message: '用户删除成功',
                  type: 'success'
                })
                this.init()
              })
            })
            .catch(() => {})
      }
    },
    handleControlFun(v, x) {
      switch (x) {
        case 'add':
          this.funAdd.show = true
          this.funAdd.id = null
          break
        case 'user':
          this.funUser.show = true
          this.funUser.id = v.id
          this.funUser.id1 = v.internal_user_id
          break
        case 'edit':
          this.funAdd.show = true
          this.funAdd.id = v.id
          break
        default:
          this.$confirm('确认删除该功能室吗?', '提示', {})
            .then(() => {
              api.mine.delete.room({ id: v.id }).then(() => {
                this.$message({
                  message: '功能室删除成功',
                  type: 'success'
                })
                this.init()
              })
            })
            .catch(() => {})
      }
    },
    handleControlGrade(v, x) {
      switch (x) {
        case 'add':
          this.gradeAdd.show = true
          this.gradeAdd.id = null
          break
        case 'edit':
          this.gradeAdd.show = true
          this.gradeAdd.id = v.id
          break
        default:
          this.$confirm('确认删除该教室吗?', '提示', {})
            .then(() => {
              api.mine.delete.grade({ id: v.id }).then(() => {
                this.$message({
                  message: '教室删除成功',
                  type: 'success'
                })
                this.init()
              })
            })
            .catch(() => {})
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user'
    })
  }
}
</script>

<style scoped lang="scss">
.set {
  @include fun-layout(1);
  display: flex;
  justify-content: center;
  width: 66%;
  margin: 0 auto;
  &-tabs {
    display: flex;
    flex-direction: column;
    margin-right: 18px;
    &-item {
      text-align: center;
      font-size: 14px;
      color: #333;
      line-height: 50px;
      width: 140px;
      cursor: pointer;
      margin-bottom: 2px;
    }
    .activeTab {
      @include fun-active(2);
    }
  }
  > div {
    @include fun-layout(2);
    height: 100%;
    width: 1702px;
    padding: 30px 20px;
    > section {
      height: 100%;
    }
  }
}

</style>
